<template>
  <div>
    <template v-if="!pageError">
      <div
          class="preview-page-tips"
          :class="allowEdit?'enabled-edit':'disabled-edit'"
          ref="fixedHeader"
      >
        <template v-if="allowEdit">
          <span>点击</span>
          <span @click="onEditAnswer" class="text-theme"> 修改 </span>
          <span>，可修改已填内容</span>
        </template>
        <template v-else>
          <span>已填内容仅可查看，不可修改</span>
        </template>
      </div>
      <div ref="mainContainer" class="preview-container">
        <div v-if="surveyTitle" class="flex justify-between py-2 px-5">
          <div class="flex-1 break-words">
            <div v-html="surveyTitle"></div>
          </div>
<!--          <div v-if="editSubmit || agentEdit" class="preview-edit-btn" @click="onEditAnswer">-->
<!--            <span>修改</span>-->
<!--            <van-icon name="edit" />-->
<!--          </div>-->
        </div>
        <div class="question-group relative" ref="mainContainer">
          <template v-if="isEditAnswer">
            <div v-for="question in list" :key="question.q_id">
              <question :question="question" />
            </div>
          </template>
          <template v-else>
            <div v-for="question in list" :key="question.q_id" class="relative">
              <preview-question :question="question" />
              <div class="absolute inset-0"></div>
            </div>
          </template>
        </div>
      </div>
      <div class="btn-wrapper px-4 py-2" ref="footerContainer">
        <div class="flex">
          <template v-if="!isEditAnswer">
            <van-button
                class="flex-1"
                v-if="showPrevBtn"
                :class="{ 'mr-4 ': showNextBtn }"
                type="primary"
                :block="!showNextBtn"
                @click="getPrevPage"
                size="small"
            >上一页
            </van-button>
            <van-button v-if="showNextBtn" class="flex-1" type="primary" :block="!showPrevBtn" @click="getNextPage"
                        size="small"
            >下一页
            </van-button>
          </template>
          <template v-else>
            <van-button block size="small" type="primary" @click="onSubmitEdit">提交修改</van-button>
          </template>
        </div>
        <template v-if="answerId">
          <div class="text-small mt-2 answer-id text-center text-theme-black-450 w-full" @click="onCopyAnswerId">
            <span class="text-small">{{ answerId }}</span>
            <span>
              <img src="~@/assets/img/svg/copy.svg" />
            </span>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <page-error :description="pageErrorMsg" />
    </template>
  </div>
</template>

<script>
import { answerPreview, copyText } from 'dygc'
import PreviewQuestion from '@/components/PreviewQuestion'
import Question from '../components/Question'
import PageError from '@/components/PageError'
import { Notify } from 'vant'

export default {
  name: 'Preview',
  components: { PageError, Question, PreviewQuestion },
  extends: answerPreview,
  props: {
    otherOffset: {
      type: Number,
      default: 0
    },
    agentEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allowEdit() {
      return this.editSubmit || this.agentEdit
    }
  },
  methods: {
    initHeight() {
      let copyrightEl = this.$refs.footerContainer.getElementsByClassName('copyright')[0]
      if (copyrightEl) {
        this.$refs.footerContainer.style.paddingBottom = copyrightEl.clientHeight + 20 + 'px'
      }
      const innerHeight = this.$bus.innerHeight
      const mainOffsetTop = this.$refs.mainContainer.offsetTop
      const mainMinHeight = innerHeight - mainOffsetTop - this.$refs.footerContainer.clientHeight - this.otherOffset
      this.$refs.mainContainer.style.minHeight = mainMinHeight + 'px'
      this.$refs.mainContainer.style.paddingTop = this.$refs.fixedHeader.clientHeight + 'px'
    },
    onCopyAnswerId() {
      copyText('.answer-id', this.answerId).then(() => {
        Notify({
          message: '复制成功',
          type: 'primary'
        })
      })
    }
  },
  mounted() {
    this.initHeight()
  },
  watch: {
    list() {
      this.$nextTick(() => {
        this.initHeight()
      })
    }
  }
}
</script>
<style lang="scss">
.preview-page-tips {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 100;
  padding: 8px 0;
  font-size: 12px;

  text-align: center;
  line-height: 16px;

  &.enabled-edit {
    color: rgba(0, 0, 0, .65);
    background-color: #F0F8FF;
  }

  &.disabled-edit {
    color: #E34152;
    background-color: #FFF1F0;
  }
}

.preview-container {
  box-sizing: border-box;
}
</style>
